'use client'

import { api } from '@/api/v2/api'
import type { MyUser } from '@/api/v2/types'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

async function fetchUser() {
  try {
    const { data } = await api.get<MyUser>('/user')
    return data
  } catch {
    window.localStorage.removeItem('access_token')
    return null
  }
}

function reloadSportsIframe() {
  const iframe = document.getElementById(
    'iframe-sports'
  ) as HTMLIFrameElement | null

  if (iframe) {
    iframe.src = iframe.src
  }
}

export function useHasAuthToken() {
  return typeof window !== 'undefined'
    ? window.localStorage.getItem('access_token') !== null
    : false
}

export default function useAuth() {
  const queryClient = useQueryClient()

  const { data: user, isInitialLoading: isAuthenticating } = useQuery(
    ['user'],
    fetchUser,
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled:
        typeof window === 'undefined'
          ? false
          : window.localStorage.getItem('access_token') !== null,
    }
  )

  const logout = useCallback(async () => {
    reloadSportsIframe()

    window.localStorage.removeItem('access_token')
    queryClient.resetQueries(['user'])

    try {
      await api.post('/logout', null, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('access_token')}`,
        },
      })
    } catch (error) {
      console.error('Error logging out', error)
    }
  }, [queryClient])

  return {
    user,
    isAuthenticated: !!user,
    isAuthenticating,
    logout,
  }
}
